import { render, staticRenderFns } from "./CreateTickets.vue?vue&type=template&id=7e45de3c&scoped=true"
import script from "./CreateTickets.vue?vue&type=script&lang=js"
export * from "./CreateTickets.vue?vue&type=script&lang=js"
import style0 from "./CreateTickets.vue?vue&type=style&index=0&id=7e45de3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e45de3c",
  null
  
)

export default component.exports